@if (type() === 'create-new') {
  <create-port-report (save)="onSaveCreate()" (close)="onClose()"></create-port-report>
} @else if (type() === 'details') {
  <port-report-details (close)="onClose()">˝</port-report-details>
}
